var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vmp-custom-menu-textlink"},[_c('div',{staticClass:"textlink-previewbox"},[_c('div',{staticClass:"textlink"},[_c('span',{on:{"click":_vm.jump}},[_vm._v(_vm._s(_vm.info.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }